import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormHexagon"><Path d="M21.2285 6.67285V17.3271L12.001 22.6543L2.77344 17.3271V6.67285L12.001 1.3457L21.2285 6.67285Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormHexagon;
